import { render, staticRenderFns } from "./BottomNavigationBar.vue?vue&type=template&id=5cf91d6e&"
import script from "./BottomNavigationBar.vue?vue&type=script&lang=ts&"
export * from "./BottomNavigationBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports